import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useDocumentTitle = (titleKey: string = 'meta.title') => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t(titleKey);
  }, [t, titleKey]);
};
